/**
 * Same dual-cloud signals as BUS-Services / BUS-Commons EnvironmentConstants.isGcpDeployment():
 * - SECRETS_MANAGER_PROVIDER=gcp → GCP
 * - SECRETS_MANAGER_PROVIDER=aws → AWS
 * - else GCP_ENV=npd|prd → GCP
 * - else AWS (ECS) defaults
 *
 * AWS/ECS staging: leave SECRETS_MANAGER_PROVIDER unset or set to aws (conf/release style).
 * Never call AWS/GCP Secrets Manager from renderer — there are no DB secrets here.
 */

const NON_PROD_ENVS = new Set(['npd', 'qa', 'dev', 'staging', 'alpha']);

const isGcpDeployment = () => {
  const provider = (process.env.SECRETS_MANAGER_PROVIDER || '')
    .trim()
    .toLowerCase();
  if (provider === 'gcp') {
    return true;
  }
  if (provider === 'aws') {
    return false;
  }
  const gcpEnv = (process.env.GCP_ENV || '').trim().toLowerCase();
  return gcpEnv === 'npd' || gcpEnv === 'prd';
};

const resolveRuntimeEnv = () =>
  (
    process.env.GCP_ENV ||
    process.env.DD_ENV ||
    process.env.AWS_ENV ||
    process.env.APP_ENV ||
    process.env.NODE_ENV ||
    'production'
  ).toLowerCase();

const isNonProdEnv = () => NON_PROD_ENVS.has(resolveRuntimeEnv());

module.exports = {
  isGcpDeployment,
  resolveRuntimeEnv,
  isNonProdEnv,
};
